import script from "./InputSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./InputSearch.vue?vue&type=script&setup=true&lang=js"

import "./InputSearch.vue?vue&type=style&index=0&id=70efc064&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70efc064"]])

export default __exports__